import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { CountryModel } from './../country/country';
import { CountryGroupModel } from './countrygroup';
import { CountryGroup } from './cougroup';
import { SelectCountry } from './sCmbCountry';
import { ComboCountryGroup } from './combocountrygroup';
import { HttpManagerService } from '../../api/httpmanager.service';

import { MasterDataConstant } from '../../api/masterdata.constant';

@Injectable()
export class CountryGroupService {
    constructor(
        private masterdataservice : MasterDataConstant,
        private httpmanagerService: HttpManagerService
    ) {
    }
    allCountygroup(): Promise<CountryGroupModel[]> {
        return this.httpmanagerService.HttpGet('countrygroup', "").then(data => {
            return data.data;
        })
    }
    selectCountrygroup(id): Promise<CountryGroupModel[]> {
        return this.httpmanagerService.HttpGet('goCountry', id).then(data => {
            return data.data;
        })
    }
    ComboCountryGroup(): Promise<ComboCountryGroup[]> {
        if(this.masterdataservice.CountryGroupList == undefined)
        {
            this.masterdataservice.CountryGroupList = [];
        }
        if(this.masterdataservice.CountryGroupList.length == 0)
        {
            return this.httpmanagerService.HttpGet('countrygroup', "").then(data => {
                this.masterdataservice.CountryGroupList = data.data;
                return data.data;
            })
        }
        else
        {
            return new Promise( resolve => {
                resolve(this.masterdataservice.CountryGroupList);
              } );
        }
    }
    iCountygroup(countyGroup): Promise<CountryGroup> {
        return this.httpmanagerService.HttpPost('countrygroup', JSON.stringify(countyGroup), "").then(data => {
            return data;
        })
    }
    uCountygroup(id, CountryGroup) {
        return this.httpmanagerService.HttpPut('countrygroup', JSON.stringify(CountryGroup), id).then(data => {
            return data;
        })
    }
    dCountryGroup(id, CountryGroup) {
        return this.httpmanagerService.HttpPut('countrygroup/deactivegroup', JSON.stringify(CountryGroup), id).then(data => {
            return data;
        })
    }
    allCountryList(): Promise<CountryModel[]> {
        if(this.masterdataservice.CountryList == undefined)
        {
            this.masterdataservice.CountryList = [];
        }
        if(this.masterdataservice.CountryList.length == 0)
        {
            return this.httpmanagerService.HttpGet('country', "").then(data => {
                this.masterdataservice.CountryList = data.data;
                return data.data;
            })
        }
        else
        {
            return new Promise( resolve => {
                resolve(this.masterdataservice.CountryList);
              } );
        }
    }
    allSelectCountryList(id): Promise<SelectCountry> {
        return this.httpmanagerService.HttpGet('countrygroup/getbyid', id).then(data => {
            return data.data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/countrygroup/countrygroup.service.ts